import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../shared/modals/modal.component';
import { requiredWhenPresent } from '../../shared/propTypes';
import { ScenarioPropType } from '../shared/propTypes';


const DeleteScenarioModalComponent = ({
  rowIndex,
  entityToRemove,
  removeEntity,
  hideModal,
  isVisible,
  isRemovingInProgress,
}) => {
  const removeBookToTaxDifference = useCallback(() => {
    removeEntity(entityToRemove, { rowIndex });
  }, [removeEntity, entityToRemove, rowIndex]);

  return (
    <Modal
      className="delete-scenario-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Scenario"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeBookToTaxDifference}
      isVisible={isVisible}
      isSubmitting={isRemovingInProgress}
    >
      {
        entityToRemove
          ? (
            <div>
              Are you sure you want to delete {entityToRemove.scenarioName}?
            </div>
          )
          : null
      }
    </Modal>
  );
};

DeleteScenarioModalComponent.propTypes = {
  entityToRemove: ScenarioPropType,
  hideModal: PropTypes.func.isRequired,
  removeEntity: PropTypes.func.isRequired,
  isRemovingInProgress: PropTypes.bool,
  rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),
  isVisible: PropTypes.bool,
};

export default DeleteScenarioModalComponent;

